import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { darken } from '@material-ui/core/styles';
import { AD } from './adsAgentTokens';

// Asks a visitor who used their free generation to sign up for more.

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
    padding: 16,
    marginBottom: 16,
    borderRadius: AD.radiusLg,
    background: AD.primarySoft,
    border: `1px solid ${AD.border}`,
    fontFamily: AD.fontFamily,
  },
  title: {
    margin: 0,
    fontSize: 15,
    fontWeight: 700,
    color: AD.primary,
  },
  text: {
    margin: '4px 0 0',
    fontSize: 13,
    lineHeight: 1.5,
    color: AD.textMuted,
  },
  signup: {
    height: AD.controlHeight,
    padding: '0 16px',
    borderRadius: AD.radiusLg,
    background: AD.cta,
    color: AD.onPrimary,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: 12.5,
    whiteSpace: 'nowrap',
    '&:hover': { background: darken(AD.cta, 0.15) },
  },
}));

const JoinAiSensyCard = (props: Props): React.ReactElement => {
  const { signupUrl } = props;
  const classes = useStyles();

  return (
    <div className={classes.root} role="note">
      <div>
        <h3 className={classes.title}>Want more ads? Join AiSensy</h3>
        <p className={classes.text}>
          You&apos;ve used your free ad generation. Sign up to generate more ads and run them on
          Facebook &amp; Instagram.
        </p>
      </div>
      <Button
        className={classes.signup}
        component="a"
        href={signupUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        Sign up to generate more
      </Button>
    </div>
  );
};

interface Props {
  signupUrl: string;
}

export default JoinAiSensyCard;
